<template>
  <div class="wechatComplaint">
    <div class="wechatComplaint-main">
      <div class="wechatComplaint-main-contain">
        <module-title title="">
          <div class="right">
            <el-button type="primary" size="medium" @click="handle('add',null)">
              添加投诉名称
            </el-button>
            <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
              返回上一页
            </el-button>
          </div>
        </module-title>
        <multiple-box :visible="isSelection" :selection-num="selectionNum">
          <span class="handle-span" @click="multipleDel">批量删除</span>
        </multiple-box>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column width="55" type="index" align="center" label="序号" />
          <el-table-column label="投诉名称" prop="typeName" align="center" />
          <el-table-column label="添加时间" prop="createDate" align="center" />
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="multipleDel(scope.row)"
              >
                删除
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="handle('edit', scope.row)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      v-if="dialogVisible"
      :title="titleType === 'add' ? '新增投诉名称' : '编辑投诉名称'"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="投诉类型：" prop="type">
          <div>{{ updateRow.typeName }}</div>
        </el-form-item>
        <el-form-item label="投诉名称：" prop="name">
          <el-input v-model="ruleForm.name" maxlength="20" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {
  getSubTypes,
  // deleteRow,
  deleteRow,
  updateComplaintName,
  addComplaintName
} from '@/api/systemMaintenance/devicManage/wechatComplaint';
import { mapGetters } from 'vuex';

export default {
  name: 'CascaderConfig',
  props: {
    detailProps: {
      type: Object,
      default: Object
    },
    updateRow: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      ruleForm: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入投诉名称', trigger: 'blur' }
        ]
      },
      // 搜索表单
      id: '',
      dataList: [],
      dialogVisible: false,
      titleType: 'add',
      multipleSelection: [], // 表格多选,
      listLoading: false // 表格刷新loading
    };
  },
  computed: {
    // 是否多选
    isSelection() {
      return this.multipleSelection.length > 0;
    },
    // 多选数量
    selectionNum() {
      return this.multipleSelection.length;
    },
    ...mapGetters(['userInfo']),
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    }
  },
  watch: {
    // 路由监听赋值三级菜单
    detailProps: {
      handler: function(val, oldVal) {
        val.id ? this.id = val.id : this.id = '';
        this.fetchdataList();
      },
      // $route这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  mounted() {
    this.fetchdataList();
  },
  methods: {
    handle(type, row) {
      this.titleType = type;
      this.dialogVisible = true;
      this.ruleForm.name = '';
      this.ruleForm.id = '';
      if (row) {
        this.ruleForm.name = row.typeName;
        this.ruleForm.id = row.id;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            typeName: this.ruleForm.name,
            updateUserCode: this.userCode,
            sort: 0,
            parentId: this.updateRow.id
          };
          if (this.ruleForm.id) {
            updateComplaintName(this.ruleForm.id, data).then(res => {
              this.fetchdataList();
              this.dialogVisible = false;
              this.$notify.success({
                title: 'Success',
                message: `操作成功`,
                showClose: false,
                duration: 2000
              });
            });
          } else {
            addComplaintName(data).then(res => {
              this.fetchdataList();
              this.dialogVisible = false;
              this.$notify.success({
                title: 'Success',
                message: `操作成功`,
                showClose: false,
                duration: 2000
              });
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
      this.$refs.ruleForm.resetFields();
    },
    cancel() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    multipleDel(row) {
      let noticeIds = [];
      if (this.multipleSelection.length > 0) {
        noticeIds = this.multipleSelection.map(x => x.id).join(',');
      } else {
        noticeIds = row.id;
      }
      this.$confirm(
        `确定要删除该投诉么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        return deleteRow(noticeIds);
      }).then(res => {
        this.$notify.success({
          title: 'Success',
          message: `删除成功`,
          showClose: false,
          duration: 2000
        });
        this.fetchdataList();
      }).catch(err => {
        console.log(err);
      });
    },
    // multipleDel(row) {
    //   this.$confirm(
    //     `确定要删除该投诉么?`,
    //     '提示',
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }
    //   ).then(() => {
    //     return deleteRow(row.id);
    //   }).then(res => {
    //     this.$notify.success({
    //       title: 'Success',
    //       message: `删除成功`,
    //       showClose: false,
    //       duration: 2000
    //     });
    //     this.fetchdataList();
    //   }).catch(err => {
    //     console.log(err);
    //   });
    // },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取应用列表
    fetchdataList() {
      this.listLoading = true;
      getSubTypes(this.id)
        .then(result => {
          if (result.data) {
            this.dataList = result.data;
          } else {
            this.dataList = [];
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.dataList = [];
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.wechatComplaint {
  padding-bottom: 20px;
  .handle-form-input {
    width: 80%;
  }
}
</style>

